// THIS FILE WAS AUTOGENERATED BY SVGR. DO NOT MODIFY IT MANUALLY;
import { Ref, SVGProps, forwardRef, memo } from 'react'

const SvgEmptyStateIllustration = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width={162}
    height={108}
    viewBox="0 0 162 108"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g clipPath="url(#clip0_1008_6548)" fill="#BBD9F6" fillOpacity={0.13}>
      <path d="M0 54h6v6H0v-6ZM18 84h-6v-6h6v6ZM24 84v-6h6v6h-6ZM24 90v-6h-6v6h-6v6h6v-6h6ZM30 90v6h-6v-6h6ZM36 90h-6v-6h6v6ZM36 78h6v6h-6v-6ZM36 72h6v-6h-6v6ZM36 72v6h-6v-6h6ZM36 90v6h6v-6h-6Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 60H6v6H0v6h6v6H0v6h6v6H0v6h6v6H0v6h6v-6h6v6h6v-6h6v6h6v-6h6v6h6v-6h6v6h6v-6h-6v-6h6v-6h-6v-6h6v-6h-6v-6h6v-6h-6v-6h6v-6h-6v6h-6v-6h-6v6h-6v-6h-6v6h-6v-6h-6v6Zm0 6v-6h6v6h-6Zm0 6v-6H6v6h6Zm6 0v-6h6v6h-6Zm0 6v-6h-6v6H6v6h6v6H6v6h6v6h6v-6h6v6h6v-6h6v6h6v-6h6v-6h-6v-6h6v-6h-6v-6h6v-6h-6v-6h-6v6h-6v-6h-6v6h6v6h-6v6h-6Z"
      />
      <g clipPath="url(#clip1_1008_6548)">
        <path d="M162 60h-54v-6h54v6ZM162 108h-54v-6h54v6ZM108 96h54v-6h-54v6ZM162 72h-54v-6h54v6ZM108 84h54v-6h-54v6Z" />
      </g>
      <g clipPath="url(#clip2_1008_6548)">
        <path d="M54 .02v6.002C80.146 6.8 101.2 27.854 101.978 54h6.002C107.198 24.54 83.46.802 54 .02Z" />
        <path d="M95.975 54C95.2 31.168 76.832 12.8 54 12.025v6.004C73.518 18.797 89.203 34.483 89.97 54h6.005Z" />
        <path d="M84 54c0-16.569-13.431-30-30-30v6c13.255 0 24 10.745 24 24h6Z" />
        <path d="M72 54c0-9.941-8.059-18-18-18v6c6.627 0 12 5.373 12 12h6ZM60 54a6 6 0 0 0-6-6v6h6Z" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1008_6548">
        <path fill="#fff" d="M0 0h162v108H0z" />
      </clipPath>
      <clipPath id="clip1_1008_6548">
        <path fill="#fff" transform="translate(108 54)" d="M0 0h54v54H0z" />
      </clipPath>
      <clipPath id="clip2_1008_6548">
        <path fill="#fff" transform="translate(54)" d="M0 0h54v54H0z" />
      </clipPath>
    </defs>
  </svg>
))
SvgEmptyStateIllustration.displayName = 'SvgEmptyStateIllustration'
const Memo = memo(SvgEmptyStateIllustration)
export { Memo as SvgEmptyStateIllustration }
